import { useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Navbar1 from './components/Navbar1';
import Footer from './components/Footer';
import { route } from './routes';
import './custom.js';

function App() {
  const location = useLocation();

  const isHomeCopyNew = location.pathname === '/10-days-free-trial-new';

  const wrapperRef = useRef(null);
  useEffect(() => {
    if (wrapperRef.current) {
      if (location.pathname === '/' || location.pathname === '/10-days-free-trial-new') {
        wrapperRef.current.classList.add('newCopy');
      } else {
        wrapperRef.current.classList.remove('newCopy');
      }
    }
  }, [location.pathname]);
  return (
    <>
    <div ref={wrapperRef}>
      {isHomeCopyNew ? <Navbar1 /> : <Navbar />}

      <Routes>
        {route.map((route, index) => (
          <Route path={route.path} element={route.component} key={index} />
        ))}
      </Routes>

      <Footer />
      </div>
    </>
  );
}

export default App;
